import { NgModule } from '@angular/core';
import { provideRouter, RouterModule, Routes, withInMemoryScrolling } from '@angular/router';
import { adminGuard } from './guards/admin.guard';
import { studentGuard } from './guards/student.guard';
import { trainerGuard } from './guards/trainer-guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./public/public-module').then(m => m.PublicModule)
  },
  {
    path: 'admin',
    canActivate: [adminGuard],
    loadChildren: () => import('./admin/admin-module').then(m => m.AdminModule)
  },
  {
    path: 'student',
    canActivate: [studentGuard],
    loadChildren: () => import('./student-dashboard/student-dashboard-module').then(m => m.StudentDashboardModule),
  },
  {
    path: 'trainer',
    canActivate: [trainerGuard],
    loadChildren: () => import('./trainer-module/trainer-module-module').then(m => m.TrainerModuleModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })
    )
  ]
})
export class AppRoutingModule {}
